import clsx from 'clsx';
import React from 'react';
import { Link } from '@common/components';
import { imagePath } from '@common/services/images-service';
import { Colors } from '@common/tokens';

export const Logo = ({ to, active }: { to: string; active: boolean }) => (
  <>
    <Link to={to}>
      <div
        className={clsx('sidebar-logo', {
          active,
        })}
      >
        <img
          className="logo"
          src={imagePath('./works-logo-white.svg')}
          alt="Trusted Works"
          width="47px"
          height="92px"
        />
      </div>
      <style jsx>{`
        .sidebar-logo {
          width: 100%;
          height: 72px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.3s linear;
          background-color: rgba(26, 25, 25, 0.25); // Elm / Hyper Dark
        }

        .sidebar-logo.active {
          background-color: ${Colors.elm};
        }

        .sidebar-logo:hover {
          background-color: ${Colors.elmDarker};
        }
      `}</style>
    </Link>
  </>
);
